













































import Vue from "vue";
import store, { DebitPaymentStore } from "../services/DebitPaymentStore";
import MoneyDisplay from "../../../components/MoneyDisplay.vue";
import { t } from "@/plugins/i18n";

interface Data {
  store: DebitPaymentStore;
}

export default Vue.extend<Data, {}, {}, {}>({
  components: {
    MoneyDisplay,
  },

  data() {
    return {
      store,
    };
  },

  computed: {
    columns: () => [
      { field: "certifNo", title: t("Szallitolevel"), headerClassName: "center_text", className: "center_text" },
      { field: "partsName", title: t("Cikk"), headerClassName: "center_text", className: "center_text" },
      { cell: "isRetTemplate", title: t("DebitPayment_Visszaru"), headerClassName: "center_text" },
      { cell: "originalPriceTemplate", title: t("DebitPayment_EredetiAr"), headerClassName: "right_text" },
      {
        cell: "modPriceTemplate",
        title: t("DebitPayment_HelyesbitesErteke"),
        headerClassName: "right_text",
      },
      { cell: "debitPriceTemplate", title: t("DebitPayment_ModosultAr"), headerClassName: "right_text" },
      { field: "reQuantity", title: t("DebitPayment_ViszaruzottMennyiseg"), headerClassName: "right_text", className: "right_text" },
      {
        field: "fixedQuantity",
        title: t("DebitPayment_HelyesbitettMennyiseg"),
        headerClassName: "right_text",
        className: "right_text",
      },
      { field: "statusName", title: t("Statusz"), headerClassName: "center_text", className: "center_text" },
      { field: "insUser", title: t("Rogzito"), headerClassName: "center_text", className: "center_text" },
      { cell: "descriptionTemplate", title: t("Megjegyzes"), headerClassName: "center_text" },
      { width: 0, filterable: false },
    ],
  },
});
